import {Information} from "@web-libs/features/information/domain/information.types";
import {ContentSlide} from "@web-libs/ui/ui-components/slider/content-slider.types";

export const toContentSlides = async (information: Information[]): Promise<ContentSlide[]> => {
    return information.map(singleInformation => {
        return {
            navId: singleInformation.id,
            mainText: singleInformation.title,
            secondaryText: singleInformation.subtitle,
            background: singleInformation.titleImage? singleInformation.titleImage.fileUrl:undefined
        }
    });
}
